import { RootState } from '../../main/store/main.store.ts';
import { AppStateEnum } from '../../main/types/app-state.types.ts';

export const selectAppState = (state: RootState): AppStateEnum => state.appState.state;
